import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { BaseHttpService } from "@shared/services/base-http.service";

import { FolderItemModel, FolderModel } from "../models/folder.model";

@Injectable({
  providedIn: "root"
})
export class FolderHttpService extends BaseHttpService {
  protected override baseEndpoint = "folders";

  getAllUserFolders(): Observable<FolderModel[]> {
    return this.getManyWithoutPagination({
      endpoint: "all",
      type: FolderModel
    });
  }

  createFolder(name: string): Observable<FolderModel> {
    return this.post<FolderModel>({
      endpoint: "",
      body: { name },
      type: FolderModel
    });
  }

  updateFolderName(id: string, name: string): Observable<FolderModel> {
    return this.patch<FolderModel>({
      endpoint: `${id}/name`,
      body: { name },
      type: FolderModel
    });
  }

  deleteFolder(folderId: string): Observable<void> {
    return this.delete<void>({
      endpoint: folderId
    });
  }

  setPublic(id: string, isPublic: boolean, action?: "MAKE_PRIVATE" | "LEAVE_PUBLIC"): Observable<FolderItemModel> {
    return this.patch<FolderItemModel>({
      endpoint: `${id}/public`,
      body: { isPublic, action },
      type: FolderItemModel
    });
  }

  getPublicFolder(folderId: string): Observable<FolderModel> {
    return this.get<FolderModel>({
      endpoint: `public/${folderId}`,
      type: FolderModel
    });
  }
}
